if (!customElements.get('rs-product-detail')) {
  customElements.define('rs-product-detail', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.grades = [...this.querySelectorAll('[data-rs-grade]')];
      this.group = this.querySelector('[data-rs-grades]');
      this.form = document.getElementById(this.dataset.formId);
      if (this.group && this.grades.length) {
        this.group.setAttribute('role', 'radiogroup');
        this.grades.forEach((grade, index) => {
          grade.setAttribute('role', 'radio');
          grade.addEventListener('click', event => { event.preventDefault(); this.select(grade, true); }, options);
          grade.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') target = (index + 1) % this.grades.length;
            if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') target = (index + this.grades.length - 1) % this.grades.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.grades.length - 1;
            if (event.key === ' ') target = index;
            if (target !== undefined) { event.preventDefault(); this.grades[target].focus(); this.select(this.grades[target], true); }
          }, options);
        });
        this.select(this.grades.find(grade => grade.dataset.gradeCurrent === 'true') || this.grades[0], false);
      }
      this.form?.addEventListener('submit', event => {
        if (this.selected?.dataset.gradeAvailable !== 'true') { event.preventDefault(); event.stopImmediatePropagation(); }
      }, { ...options, capture: true });
      const primary = this.form?.querySelector('[name="add"]');
      const secondary = [...this.querySelectorAll('button[data-actual-purchase]')];
      const feedback = this.querySelector('[data-cart-feedback]');
      if (primary && secondary.length) {
        this.observer = new MutationObserver(() => {
          const busy = primary.getAttribute('aria-disabled') === 'true';
          secondary.forEach(button => {
            button.disabled = busy || this.selected?.dataset.gradeAvailable !== 'true';
            button.setAttribute('aria-busy', String(busy));
          });
          const error = this.querySelector('.product-form__error-message');
          if (feedback) feedback.textContent = error?.textContent || '';
        });
        this.observer.observe(primary, { attributes: true, attributeFilter: ['aria-disabled'] });
      }
      const sticky = this.querySelector('[data-sticky-purchase]');
      const purchase = this.querySelector('[data-primary-buy]');
      const summary = this.querySelector('.rs-pdp__summary');
      if (sticky && purchase && 'IntersectionObserver' in window) {
        this.stickyObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === purchase) this.passedPurchase = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            if (entry.target === summary) this.summaryVisible = entry.isIntersecting;
          });
          sticky.hidden = !this.passedPurchase || this.summaryVisible;
        });
        this.stickyObserver.observe(purchase);
        if (summary) this.stickyObserver.observe(summary);
      }
      this.setAttribute('data-ready', 'true');
    }
    select(grade, announce) {
      this.selected = grade;
      const available = grade.dataset.gradeAvailable === 'true';
      this.grades.forEach(option => {
        const selected = option === grade;
        option.setAttribute('aria-checked', String(selected));
        option.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-selected-grade]').forEach(node => { node.textContent = grade.dataset.gradeLabel; });
      this.querySelectorAll('[data-selected-price]').forEach(node => { node.textContent = grade.dataset.gradePrice; });
      this.querySelectorAll('[data-price-label]').forEach(node => { node.textContent = available ? this.dataset.actualLabel : this.dataset.estimateLabel; });
      this.querySelectorAll('[data-actual-purchase]').forEach(node => { node.hidden = !available; if (node.tagName === 'BUTTON') node.disabled = !available; });
      this.querySelectorAll('[data-request-purchase]').forEach(node => { node.hidden = available; if (!available) node.href = grade.href; });
      this.querySelectorAll('[data-selected-stock]').forEach(node => { node.textContent = available ? this.dataset.availableLabel : this.dataset.requestLabel; node.dataset.inStock = String(available); });
      this.querySelectorAll('[data-request-note]').forEach(node => { node.hidden = available; });
      this.querySelectorAll('[data-defect-note]').forEach(node => { node.hidden = grade.dataset.rsGrade !== 'G4'; });
      const busy = this.form?.querySelector('[name="add"]')?.getAttribute('aria-disabled') === 'true';
      this.querySelectorAll('button[data-actual-purchase]').forEach(button => { button.disabled = !available || busy; });
      if (announce) this.querySelector('[data-grade-announcement]').textContent = `${grade.dataset.gradeLabel}. ${grade.dataset.gradePrice}. ${available ? this.dataset.availableLabel : this.dataset.requestLabel}`;
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.stickyObserver?.disconnect(); this.controller = null; }
  });
}

